// extracted by mini-css-extract-plugin
module.exports = {"light_ui-input-text-color":"#000","light_input-warning-color":"#f5222d","dark_ui-input-text-bg-color":"#000","dark_ui-input-text-color":"#fff","dark_input-warning-color":"#f5222d"};